import type React from 'react'
import type { ReactElement } from 'react'

export function IconAlertCritical(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg width={24} height={24} xmlns={'http://www.w3.org/2000/svg'} viewBox={'0 0 24 24'} {...props}>
      <path
        d={
          'M15.4648 3.98809L22.467 16.0932C23.9919 18.7299 22.0614 22 19.0022 22H4.99841C1.93862 22 0.00750279 18.7303 1.53354 16.0932L5.78198 12.4016L3.12355 16.9979C2.30533 18.4116 3.33447 20.1819 4.99841 20.1819H19.0022C20.6649 20.1819 21.6947 18.412 20.877 16.998L14.0583 5.21002L15.4648 3.98809Z'
        }
        fill={'currentcolor'}
      />
      <path
        d={
          'M14.0583 5.21002L15.4648 3.98809C13.9321 1.3374 10.0676 1.33725 8.53495 3.98797L1.53354 16.0932L5.78198 12.4016L10.125 4.89269C10.9533 3.46002 13.0463 3.4599 13.8746 4.89256L14.0583 5.21002Z'
        }
        fill={'currentcolor'}
      />
      <path
        d={
          'M12.0003 7.4548C12.5065 7.4548 12.9168 7.86181 12.9168 8.36388V13.8183C12.9168 14.3204 12.5065 14.7274 12.0003 14.7274C11.4941 14.7274 11.0837 14.3204 11.0837 13.8183V8.36388C11.0837 7.86181 11.4941 7.4548 12.0003 7.4548Z'
        }
        fill={'currentcolor'}
      />
      <path
        d={
          'M12.9168 17.4546C12.9168 16.9526 12.5065 16.5455 12.0003 16.5455C11.4941 16.5455 11.0837 16.9526 11.0837 17.4546V17.4637C11.0837 17.9658 11.4941 18.3728 12.0003 18.3728C12.5065 18.3728 12.9168 17.9658 12.9168 17.4637V17.4546Z'
        }
        fill={'currentcolor'}
      />
    </svg>
  )
}
